import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

const Links = () => (
  <StaticQuery
    query={graphql`
      {
        allFile(
          filter: {
            internal: {mediaType: {eq: "text/markdown"}}, 
            sourceInstanceName: {eq: "case-studies"}
          }
        ) {
          edges {
            node {    
              id
              childMarkdownRemark {
                id
                frontmatter {
                    slug
                    title
                    company {
                        name
                    }
                }
              }
            }
          }
        }  
      }  
    `}
    render={(data) => {
      const caseStudies = data.allFile.edges;

      return (
        <div className="blogSidebar__section">
          <h2>Other Case Studies</h2>

          <ul className="latest__posts">
            {caseStudies.map(cs =>
              <li key={cs.node.id}>
                <div className="latest__date">{cs.node.childMarkdownRemark.frontmatter.company.name}</div>
                <div className="latest__title">
                  <a href={cs.node.childMarkdownRemark.frontmatter.slug}>{cs.node.childMarkdownRemark.frontmatter.title}</a>
                </div>
              </li>
            )}
          </ul>
        </div>
      );
    }}
  />
);

export default Links;
